import React, { useEffect, useState } from "react";
import useStyles from "../../../../components/common/model/styles";
// import ResetFormAlert from "./ResetFormAlert";
import Popup from "../../../../components/common/model/Popup";
import closeIcon from "../../../../assets/closeModel.png";
import checkedIcon from "../../../../assets/check-mark.png";
import deleteIcon from "../../../../assets/trash.png";
import { DialogContent, DialogContentText, Grid } from "@mui/material";
import Notification from "../../../../components/common/notification/Notification";
import Validation from "../../../../utils/Validation";

import FormField from "../../../../components/common/FormField";
import { useDispatch } from "react-redux";
import { setNotificationAction } from "../../../../store/reducers/mmymSlice";
import { formElementFields } from "./materialAllFields";
import {
  addMaterialAction,
  initialMaterialLocalState,
  setAddMaterialResponse,
  updateMaterialAction,
  updateMaterialResponse,
} from "../../../../store/reducers/materialSlice";
import ResetFormAlert from "../manageReffer/ResetFormAlert";

interface materialDetail {
  [key: string]: any; // Allow dynamic string keys
  name: any | null;
  rate: any | null;
  volume: any | null;
}

interface ManageMaterialProps {
  open: boolean; // Define the 'open' prop
  onHide: () => void; // Define the 'onHide' prop
  title: string; // Define the 'title' prop
  selectUser: any; // Adjust type as per your requirement
  isSmallScreen?: boolean; //
}

const ManageMaterial = (props: ManageMaterialProps) => {
  const classes = useStyles();
  const { selectUser, onHide, open, title, isSmallScreen } = props;

  const [materialDetail, setMaterialDetail] = useState<materialDetail>(
    initialMaterialLocalState?.material
  );
  const [fieldsToRender, setFieldsToRender] = useState(formElementFields); // Default to basic fields

  useEffect(() => {
    // Dynamically update form fields based on screen size
    if (isSmallScreen) {
      setFieldsToRender(formElementFields);
    }
    // else {
    //   setFieldsToRender(allFormElementFields);
    // }
  }, [isSmallScreen]);

  const [alerModeShow, setAlertModelShow] = useState(false);
  const [isClickReset, setIsClickReset] = useState(false);

  const [
    error,
    checkValidator,
    resetValidator,
    resetAllValidator,
    isError,
    isErrorOptional,
  ]: any = Validation({
    name: materialDetail?.name,
    rate: materialDetail?.rate,
    volume: materialDetail?.volume,
  });

  const dispatch = useDispatch();

  const [isActionCalled, setIsActionCalled] = useState(false);

  useEffect(() => {
    if (selectUser) {
      console.log("selectUser", selectUser);
      setMaterialDetail({
        ...materialDetail,
        name: selectUser?.name,
        rate: selectUser.rate ?? "",
        volume: selectUser.volume ?? "",
      });
    }
  }, [selectUser]);

  const hideHandler = () => {
    onHide();
    handleClear();
    dispatch(setNotificationAction({ message: [], severity: "error" }));
    dispatch(setAddMaterialResponse(false));
    dispatch(updateMaterialResponse(false));
    setMaterialDetail(initialMaterialLocalState?.material);
  };

  const handleClear = () => {
    if (selectUser?.id) {
      setMaterialDetail(selectUser);
    } else {
      setMaterialDetail(initialMaterialLocalState?.material);
    }
    resetAllValidator(); // Reset all validation errors
    setIsClickReset(false);
    setAlertModelShow(false);
    // setIsEmailActionCalled(false);
    // setRoleModules([]);
  };

  const openClearPopup = () => {
    setAlertModelShow(true);
  };

  useEffect(() => {
    if (isClickReset) {
      handleClear();
      setAlertModelShow(false);
    }
  }, [isClickReset]);

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    checkValidator();
    setIsActionCalled(true);
  };

  useEffect(() => {
    if (isActionCalled) {
      console.log("materialDetail", materialDetail);
      if (
        !isError() &&
        !isErrorOptional() &&
        error !== null &&
        isActionCalled
      ) {
        if (selectUser?.id) {
          dispatch(
            updateMaterialAction({ ...materialDetail, id: selectUser?.id })
          );
        } else {
          dispatch(addMaterialAction(materialDetail));
        }
      }
      setIsActionCalled(false);
    }
  }, [isActionCalled]);

  const handleInputChange = (field: string, value: any) => {
    console.log("field-value", field, value);
    setMaterialDetail((prevState) => ({
      ...prevState,
      [field]: value,
    }));

    // dispatch(
    //   setNewSubUserLocal({
    //     ...newUserLocal,
    //     [field]: value,
    //   })
    // );

    resetValidator(field);
  };

  const onBlurAction = (e: any) => {
    checkValidator(e.target.id);
  };
  return (
    <>
      <Popup
        open={open}
        title={title}
        onHide={hideHandler}
        fullWidth={true}
        maxWidth={"sm"}
        aria-describedby="alert-dialog-slide-description"
        popupBg="#fff"
        header={
          <>
            <img
              onClick={(e: any) => handleSubmit(e)}
              src={checkedIcon}
              className={classes.checkicons}
              alt="save"
            />
            <img
              onClick={openClearPopup}
              src={deleteIcon}
              className={classes.deleteicons}
              alt="delete"
            />
            <img
              onClick={hideHandler}
              src={closeIcon}
              className={classes.closeicons}
              alt="close"
            />
          </>
        }
      >
        <DialogContent  sx={{ padding: "16px 10px !important" }}>
          <DialogContentText >
            <>
              <Notification />
              <Grid
                container
                direction="row"
                spacing={0.5}
                rowGap={0}
                rowSpacing={0}
                sx={{
                  background: "#E5F4F1",
                  padding: "10px !important",
                  marginTop: "10px !important",
                  borderRadius: "5px",
                  border: "1px solid #CFCFCF",
                  overflow: "hidden",
                }}
              >
                {fieldsToRender.map((field, i) => {
                  return (
                    <FormField
                      onPaste={(e) =>
                        field?.id === "name" ? "" : e.preventDefault()
                      }
                      onKeyDown={(event: any) => {
                        console.log(
                          "event log-",
                          event,
                          event.target.value + event.key
                        );
                        if (
                          event.keyCode === 8 ||
                          event.keyCode === 9 ||
                          event.keyCode === 37 ||
                          event.keyCode === 38 ||
                          event.keyCode === 39 ||
                          event.keyCode === 40 ||
                          event.keyCode === 18 ||
                          event.keyCode === 17 ||
                          event.ctrlKey
                        )
                          return event;
                        if (
                          field?.patternAllowed &&
                          !field?.patternAllowed.test(event.key)
                        ) {
                          event.preventDefault();
                        } else if (
                          field?.patternAllowed &&
                          !field?.patternAllowed.test(
                            event.target.value + event.key
                          )
                        ) {
                          event.preventDefault();
                        }
                      }}
                      {...{
                        ...field,
                        ...{
                          variant: "outlined", // Adding this variant prop
                          inSingleGridForm: true,
                          isNonMarginTop: true,
                          InputProps: {
                            ...(field?.inputProps && field?.inputProps),
                            sx: {
                              height:
                                field?.id === "notes" &&
                                materialDetail[field?.id]?.length > 36
                                  ? "auto"
                                  : "36px",
                              padding: field?.id === "notes" ? "4px" : "",
                            },
                            // ...(selectUser && { disabled: field?.editReadOnly }),
                            autocomplete: "user-new-field",
                          },

                          value: materialDetail ? materialDetail[field.id] : "",
                          onBlur: onBlurAction,
                          // selectedValues: materialDetail[field?.id],
                          onChange: (e: any) =>
                            handleInputChange(field.id, e.target.value), // Call onChange prop
                          error: error && error[field?.id],
                        },
                      }}
                    />
                  );
                })}
              </Grid>
            </>
          </DialogContentText>
        </DialogContent>
      </Popup>
      {alerModeShow && (
        <ResetFormAlert
          open={alerModeShow}
          title=""
          alertModalShow={alerModeShow}
          setAlertModelShow={setAlertModelShow}
          setIsClickReset={setIsClickReset}
        />
      )}
    </>
  );
};

export default ManageMaterial;
